import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReplaceAllPipe } from './replace-all.pipe';

@NgModule({
    declarations: [
        ReplaceAllPipe
    ],
    imports: [
        CommonModule
    ],
    exports: [
        ReplaceAllPipe
    ]
})
export class PipesModule { }
